import { getGuid } from 'content-creation-common/utils/guid';
import { info } from '../../util/log';
import { inWorker } from '../../util/window';
import { isNil } from '../../util/object';

let sharedSessionToken = null;

// Ensure that you set shared token for non main thread contexts so that SessionBroadcastChannel works correctly.
export const setSharedSessionToken = (token) => {
  sharedSessionToken = token;
  Object.freeze(sharedSessionToken); // Only should be setting session token once per session
};

// Main thread can and should assign a value here when module is initialized.
export const getSharedSessionToken = () => {
  if (isNil(sharedSessionToken) && !inWorker) {
    setSharedSessionToken(getGuid());
    info(`Initialized Session token: ${sharedSessionToken}`);
  }
  return sharedSessionToken;
};
